var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LevellingPageShell',{attrs:{"title":"Pay Equity","icon":"mdi-scale-balance"}},[_c('ReportContainer',_vm._g(_vm._b({},'ReportContainer',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }